import * as React from 'react'
import classNames from 'classnames'
import { withStyles, WithStyles, Dialog } from '@zn-material-ui'
import AdornedButton from '@components/AdornedButton'
import Button from '@components/Button'
import Select from '@components/Select'
import appListDialogStyles from './styles/AppListDialogStyle'
import { transform } from '@utils/intl_lang'
export type dataType = Array<{
  title: string
  value: string
}>
interface IProps extends WithStyles<typeof appListDialogStyles> {
  loading: boolean
  handleClose?: () => void
  handleSelect: (appId: string) => () => void
  data: dataType
  title: string
}

const AppListDialog: React.SFC<IProps> = ({
  classes,
  loading,
  handleClose,
  handleSelect,
  data = [],
  title = '',
}) => {
  const [appId, setAppId] = React.useState(data[0] && data[0].value)
  const handleChange = (value: string) => {
    setAppId(value)
  }
  React.useEffect(() => {
    const item = data.find(d => d.value === appId)
    if (!item) {
      setAppId(data[0] && data[0].value)
    }
  })
  return (
    <Dialog
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      open={true}
      onClose={handleClose}
      classes={{ paper: classes.container }}
    >
      <div className={classes.dialogContent}>
        {/* <p className={classes.dialogTitle}>{`请选择要登录的${title}：`}</p> */}
        <p className={classes.dialogTitle}>
          {transform('Login_dialog_title', { title })}
        </p>
        <div style={{ marginTop: 26, marginBottom: 40 }}>
          <Select
            showTip={false}
            data={data}
            defaultValue={appId}
            onChange={handleChange}
            containerStyle={classes.containerStyle}
            collapseStyle={classes.collapseStyle}
          />
        </div>
        <div className={classes.action}>
          <AdornedButton
            variant="contained"
            className={classes.btn}
            onClick={handleSelect(appId)}
            loading={loading}
            color="primary"
          >
            {/* 确 定 */}
            {transform('confirm_empty')}
          </AdornedButton>
          {handleClose && (
            <Button
              variant="outlined"
              className={classNames(classes.btn, classes.cancelBtn)}
              onClick={handleClose}
              defaultType={true}
            >
              {/* 取 消 */}
              {transform('concel_empty')}
            </Button>
          )}
        </div>
      </div>
    </Dialog>
  )
}

export default withStyles(appListDialogStyles)(AppListDialog)
